module.exports = __webpack_public_path__ + "media/St 4-phone-tablet-question.52cf0db7.wav";